import { signalStore, type, withHooks, withState } from '@ngrx/signals';
import { forkJoin, switchMap, toArray } from 'rxjs';
import { inject } from '@angular/core';
import { Draw, DrawService } from '@unicup-ticketing/service';
import { mapResponse } from '@ngrx/operators';
import { eventGroup, Events, injectDispatch, on, withEventHandlers, withReducer } from '@ngrx/signals/events';

export const StaffProfileEvents = eventGroup({
  source: 'Staff Profile',
  events: {
    load: type<void>(),
    loadSuccess: type<{ submissionDraws: Draw[]; drawnDraws: Draw[] }>(),
    loadFailure: type<Error>(),
  },
});

export const StaffProfileStateStore = signalStore(
  withState<{
    isLoading: boolean;
    isError: boolean;
    draws:
      | {
          submission: Draw[];
          drawn: Draw[];
        }
      | undefined;
  }>({
    isLoading: false,
    isError: false,
    draws: undefined,
  }),
  withReducer(
    on(StaffProfileEvents.load, () => ({ isLoading: true })),
    on(StaffProfileEvents.loadSuccess, ({ payload: { submissionDraws, drawnDraws } }) => ({
      isLoading: false,
      draws: { submission: submissionDraws, drawn: drawnDraws },
    })),
    on(StaffProfileEvents.loadFailure, () => ({ isLoading: false, isError: true })),
  ),
  withEventHandlers((store, events = inject(Events), drawService = inject(DrawService)) => ({
    load$: events.on(StaffProfileEvents.load).pipe(
      switchMap(() =>
        forkJoin([
          drawService.retrieveDraws('submission').pipe(toArray()),
          drawService.retrieveDraws('issue').pipe(toArray()),
        ]).pipe(
          mapResponse({
            next: response => StaffProfileEvents.loadSuccess({ submissionDraws: response[0], drawnDraws: response[1] }),
            error: () => StaffProfileEvents.loadFailure(new Error('Error while loading draws')),
          }),
        ),
      ),
    ),
  })),
  withHooks(() => {
    const dispatch = injectDispatch(StaffProfileEvents);

    return {
      onInit() {
        dispatch.load();
      },
      onDestroy() {
        //
      },
    };
  }),
);
